import { $color_grey_2, $color_brand_light_bg_hover, $color_brand_text_defalut } from '../pebbleGlobalToken/color.js';

/**
 * 分页-颜色-背景-激活状态
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_grey_2
 */
var $pagination_color_bg_active = $color_grey_2;

/**
 * 分页-颜色-背景激活状态下的-hover
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_brand_light_bg_hover
 */
var $pagination_color_bg_active_hover = $color_brand_light_bg_hover;

/**
 * 分页-颜色-文本-hover
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_brand_text_defalut
 */
var $pagination_color_text_hover = $color_brand_text_defalut;

/**
 * 分页-popver padding间距
 * @description enDesc: -
 * @description type: Space
 * @description value: 16
 */
var $pagination_popover_padding = 16;

export { $pagination_color_bg_active, $pagination_color_bg_active_hover, $pagination_color_text_hover, $pagination_popover_padding };
